import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/style/home.scss';
const homeBanner = [
	// {
	// 	image: '/home/pms.png',
	// 	enImage: '/home/pms.png',
	// 	color: '#313436',
	// 	btnColor: '#fff',
	// 	url: '',
	// 	info: {
	// 		title: {
	// 			chinese: '',
	// 			english: ''
	// 		},
	// 		miantitle: {
	// 			chinese: [],
	// 			english: []
	// 		}
	// 	}
	// },
	{
		image: '/home/home-banner-usaLine.png',
		enImage: '/home/home-banner-usaLine-en.png',
		color: '#313436',
		btnColor: '#fff',
		url: '/product/1',
		info: {
			title: {
				chinese: '派敏斯美国专线',
				english: 'The PMS-US Logistics Direct Line'
			},
			miantitle: {
				chinese: ['时效3-7个工作日', '优质物流资源整合', '专业的物流团队为你提供优质服务与咨询'],
				english: ['The delivery times between 3 and 7days', 'Integration the high-quality logistics resources.', 'Professional logistics team support good service']
			}
		}
	},
	{
		image: '/home/home-banner-ukLine.png',
		enImage: '/home/home-banner-ukLine-en.png',
		color: '#fff',
		btnColor: '#313436',
		url: '/product/2',
		info: {
			title: {
				chinese: '派敏斯英国专线',
				english: 'The PMS-UK Logistics Service '
			},
			miantitle: {
				chinese: ['时效4-7个工作日', '空运妥投一站式服务', '海外仓换单服务'],
				english: ['The delivery times between 4 and 7days ', 'Air express and correct-distribute service.', 'Overseas postal label exchange service']
			}
		}
	},
	{
		image: '/home/home-banner-euroLine.png',
		enImage: '/home/home-banner-euroLine-en.png',
		color: '#fff',
		btnColor: '#313436',
		url: '/product/3',
		info: {
			title: {
				chinese: '派敏斯邮政小包服务',
				english: 'Economic Parcel Service'
			},
			miantitle: {
				chinese: ['与多家速递公司有着坚实、长期稳定的合作', '优质国际小包资源整合', '免费的揽收服务'],
				english: ['PMS has establish long-term partnership with many carriers company', 'Integration the excellent small-parcel resources among international.', 'Free collection services']
			}
		}
	}]
const homeData = {
	product: {
		title: {
			chinese: '我们的产品',
			english: 'OUR PRODUCTS'
		},
		subtitle: {
			chinese: '致力发展智能物流，美国专线，英国专线，邮政小包等服务，我们要求时效严格，全程跟踪客户的包裹信息，根据客户不同的需求，准确掌握客户信息，服务优先，并且价格合理。',
			english: 'PMS focus on the developments of intelligent logistics The main business includes US Logistics direct line, UK Logistics direct line and China Postal packet services and other services.We are serious to our delivery time and trace the packages’ information for our clients. According to the different needs of customers, we can grasp information of customers accurately, providing service priority, and using the price appropriately.'
		},
		data: [
			{
				name: {
					chinese: '美国专线',
					english: 'The PMS-US Logistics Service'
				},
				image: '/home/am-banner.png',
				url: '/product/1',
				message: {
					chinese: ['派敏斯主营业务，优质美国资源整合', '时效稳定，全程跟踪'],
					english: ['It is the main business of PMS which has full-tracking packages service.', 'And it integrate the resource of US postal service.']
				}

			}, {
				name: {
					chinese: '英国专线',
					english: 'The PMS-UK Logistics Service'
				},
				image: '/home/en-banner.png',
				url: '/product/2',
				message: {
					chinese: ['空运+派送，海外仓换单', '服务多样、安全快捷'],
					english: ['This service includes air-express and delivery, postal label exchange. ', 'It is numerous ,safety and rapidly']
				}
			},
			{
				name: {
					chinese: '德国及欧盟专线',
					english: 'DE & EU Logistics Service'
				},
				image: '/home/e-banner.png',
				url: '/product/3',
				message: {
					chinese: ['空运+派送', '优质线路、全程跟踪'],
					english: ['Air&Delivery', 'In time delivery、Fully-Tracked Service']
				}
			},
			{
				name: {
					chinese: '邮政小包服务',
					english: 'Economic Parcel Service'
				},
				image: '/home/home-airCargo.png',
				url: '/product/4',
				message: {
					chinese: ['优质的小包资源整合', '自动筛选最优的邮政小包服务'],
					english: ['Integrating the excellent small-parcels resources.', 'It can select the most suitable service for small-parcels']
				}
			},
			{
				name: {
					chinese: 'PMS空海运大货',
					english: 'PMS Air and Sea Cargo'
				},
				image: '/home/litter-banner.png',
				url: '/product/5',
				message: {
						chinese: ['为FBA专线量身打造，无论是快递、海派、空派、卡航、铁路，统统满足'],
						english: ['Tailor-made for FBA special line, whether you are doing express delivery, sea delivery, air delivery, Qatar Airways, or railway, it is all satisfied']
				}
			}
		]
	},
	news: {
		title: {
			chinese: '新闻资讯',
			english: 'NEWS'
		},
		text: {
			chinese: '新闻资讯包含海量咨询，快速捕捉出日益爆发的信息洪流中最核心的资讯，让您快速了解行业最新进展的新闻事件、热点话题、人物动态、产品咨询等，满足你对资讯的一切需求！',
			english: 'In this part, you can search the core information of the news, which can meet your needs whatever the latest developments in the news events, heated topics, dynamic of characters, product consulting, etc.'
		}
	},
	details: {
		chinese: '了解详情',
		english: 'Details'
	},
	productBtn: {
		chinese: '了解更多',
		english: 'MORE INFO'
	},
	image: {
		chinese: '派你所想，永不言退，把握现在，成就非凡未来',
		english: 'Dispatch what you think and never ever delay.'
	},
	message: {
		title: {
			chinese: '联系我们',
			english: 'CONTACT us'
		},
		text: {
			text1: {
				chinese: '派敏斯速递对您提交的个人信息资料采取保密措施，敬请放心。',
				english: 'Email us with as much detail as you can so we can give you the best help possible.'
			},
			text2: {
				chinese: '为确保我们能第一时间联系您，请务必准确填写联系方，感谢您的配合。',
				english: ''
			}
		},
		placeholder: {
			chinese: {
				username: '您的称呼：*',
				infomation: '您的联系方式：*',
				message: '留言内容：*',
				submit: '提交留言'
			},
			english: {
				username: 'Your name',
				infomation: 'Your contact information',
				message: 'Message',
				submit: 'submit'
			}
		}
	}
}
export default class Banner extends React.Component {
	state = {
		timer: 0,
	}
	constructor(props) {
		super(props);
		this.resizeBannerSwiper = this.resizeBannerSwiper.bind(this);
	}
	componentDidMount() {
		this.bannerSwiper();
	}

	resizeBannerSwiper(value) {
		return () => {
			this.setState({
				timer: value
			})
			this.bannerSwiper();
		}

	}
	componentWillUnmount() {
		window.clearInterval(window.homebannerTimer);
	}
	bannerSwiper() {
		window.homebannerTimer = window.setInterval(() => {
			let number = this.state.timer + 1;
			this.setState({
				timer: number % homeBanner.length
			})
		}, 4000)
	}
	render() {
		const { timer } = this.state;
		const { language } = this.props;
		let homebanner = homeBanner.map((image, key) =>
			<div key={key.toString()} className={key == timer ? 'home-isshow' : 'home-ishide'}>
				<img src={image[language === 'english' ? 'enImage' : 'image']} alt="" />
				{/* {key > 0 &&
					<div className="pms-home-banner-info" style={{ color: image.color }}>
						<div className=""><Link to={image.url}>{homeData.productBtn[language]}</Link></div>
					</div>
				} */}
			</div>
		)
		let homebannerpage = homeBanner.map((image, key) =>
			<span
				key={key.toString()}
				onClick={this.resizeBannerSwiper(key)}
				className={key == timer ? 'home-banner-page-active pms-container-banner-page' : 'home-banner-page-unactive pms-container-banner-page'}
			>
				<i></i>
			</span>
		)
		return (
			<div className="pms-home-banner">
				{homebanner}
				<p className="pms-container-banner-page-list">{homebannerpage}</p>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./public/views/banner.js